import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(lang)/our-services/(serviceLayoutGroup)/loading.jsx");
